<template>
  <e-sidebar
    id="sidebar-motoboy-add-order"
    :title="$t('Adicionar pedido à entrega')"
    :show="show"
    :hide-save-button="true"
    :cancel-button-text="$t('Fechar')"
    :no-close-on-backdrop="false"
    width="30%"
    @hidden="$emit('hidden')"
  >
    <template #content>
      <p
        v-if="motoboy"
        class="mb-1"
      >
        <strong>{{ $t('Motoboy') }}:</strong> {{ motoboyName(motoboy) }}
      </p>
      <small class="text-muted d-block mb-1">
        {{ $t('O pedido adicionado entra na entrega em andamento deste Motoboy.') }}
      </small>

      <FormulateInput
        id="motoboy-add-order-sidebar_filter"
        v-model="orderFilter"
        type="text"
        :label="$t('Pedido ou cliente')"
        :placeholder="$t('Filtrar por número do pedido ou nome do cliente')"
      />

      <b-alert
        :show="!filteredOrders.length"
        variant="light"
        class="mb-0"
      >
        {{
          ordersWaitingMotoboy.length
            ? $t('Nenhum pedido encontrado para o filtro informado')
            : $t('Nenhum pedido aguardando Motoboy')
        }}
      </b-alert>

      <ul class="motoboy-add-order-list list-unstyled mb-0">
        <li
          v-for="order in filteredOrders"
          :key="order.id"
          class="motoboy-add-order-list__item d-flex align-items-center justify-content-between"
        >
          <div>
            <strong>#{{ order.id }}</strong>
            <span v-if="order.customer && order.customer.name"> - {{ order.customer.name }}</span>
            <small
              v-if="order.deliveryAddress"
              class="text-muted d-block"
            >
              {{ formatOrderAddress(order.deliveryAddress) }}
            </small>
          </div>
          <e-button
            :id="`motoboy-add-order-sidebar_add-${order.id}`"
            size="sm"
            icon="plus-circle"
            :busy="isAssignmentOperationPending(order.id)"
            :text="$t('Adicionar')"
            @click="addOrder(order)"
          />
        </li>
      </ul>
    </template>
  </e-sidebar>
</template>

<script>
import { BAlert } from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import ESidebar from '@/views/components/ESidebar.vue'
import EButton from '@/views/components/EButton.vue'
import { stringUtils } from '@/mixins'
import motoboyPresence from './motoboy-presence'

export default {
  name: 'MotoboyAddOrderSidebar',

  components: {
    BAlert,
    EButton,
    ESidebar,
  },

  mixins: [motoboyPresence, stringUtils],

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    motoboy: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      orderFilter: '',
    }
  },

  computed: {
    ...mapGetters('pages/sale/deliveryDashboard', [
      'ordersWaitingMotoboy',
      'isAssignmentOperationPending',
    ]),
    // Um único campo filtra pelo número do pedido ou pelo nome do cliente.
    filteredOrders() {
      const term = this.normalizeText(this.orderFilter).trim().replace(/^#/, '')
      if (!term) return this.ordersWaitingMotoboy
      return this.ordersWaitingMotoboy.filter(
        order =>
          String(order.id).includes(term) ||
          this.normalizeText(order.customer?.name).includes(term)
      )
    },
  },

  watch: {
    show(value) {
      if (!value) this.orderFilter = ''
    },
  },

  methods: {
    normalizeText(value) {
      return this.getWithNoAccents(value || '').toLowerCase()
    },
    ...mapActions('pages/sale/deliveryDashboard', ['assignMotoboy']),
    formatOrderAddress(address) {
      const street = [address.publicPlace, address.number].filter(Boolean).join(', ')
      return [street, address.neighborhood].filter(Boolean).join(' - ')
    },
    async addOrder(order) {
      try {
        await this.assignMotoboy({
          orderId: order.id,
          motoboyId: this.motoboyId(this.motoboy),
          action: 'WaitToCompose',
        })
        this.showSuccess({ message: this.$t('Pedido adicionado à entrega') })
      } catch (error) {
        this.showError({ error })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.motoboy-add-order-list__item {
  gap: 0.5rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid #ebe9f1;

  &:last-child {
    border-bottom: 0;
  }
}
</style>
